import React, { useEffect, useState } from 'react'
import { Button, Card, Carousel, Col, Divider, Image, Input, Popconfirm, Row, Spin, Upload, message } from 'antd';
import classNames from 'classnames';
import dayjs from 'dayjs';
import { BiSolidPurchaseTag } from "react-icons/bi";
import { PiArrowFatLeftFill, PiArrowFatRightFill } from 'react-icons/pi';
import { RiShieldCheckFill } from "react-icons/ri";
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';

import PublicLayout from '../../layouts/PublicLayout';
import { CheckCircleFilled, CheckCircleTwoTone, DeleteFilled, CloseCircleFilled } from '@ant-design/icons';
import { ImgComparisonSlider } from '@img-comparison-slider/react';
import abg from "../../../assets/images/after-slider-bg.jpg";
import constants from '../../../config/constants';
import { updateOrderDetail } from '../../../redux/order/orderSlice';

import { checkPromo } from '../../../services/planAPI';

const { Dragger } = Upload;

function Step2() {

  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const isDarkMode = useSelector(state => state.app.isDarkMode);
  const orderData = useSelector(state => state.order);
  const [fileLists, setFileLists] = useState([]);

  const [processingDelay, setProcessingDelay] = useState(orderData.processingDelay);
  const [loading, setLoading] = useState(false);
  const [artist, setArtist] = useState(orderData.artist);
  const [count, setCount] = useState(orderData.fileList.length);

  useEffect(() => {
    checkPromo(location.search).then(({ data }) => {
      updateData('coupon', data.coupon);
    }).catch(err => console.log(err)).finally(() => {
      if (!orderData.name || !orderData.email) {
        updateData('step', 0);
        navigate('/order/step1');
      }
    });
    window.scrollTo(0, 0)
    updateData('step', 1);
  }, []);

  useEffect(() => {
    updateData('processingDelay', processingDelay);
  }, [processingDelay]);

  const updateData = (field, value) => {
    dispatch(updateOrderDetail({
      field,
      value,
    }));
  };

  const handleChange = (info) => {
    setFileLists([...info.fileList]);
    if (info.file.status == 'uploading') {
      setLoading(true);
    } else {
      setLoading(false);
    }
    if (info.file.status == 'done') {
      let files = [...orderData.fileList];
      updateData('fileList', [...files, {
        path: info.file.response?.path
      }]);
    }
  }

  const handleDelete = (index) => {
    let files = [...orderData.fileList];
    files.splice(index, 1);
    updateData('fileList', files);
    setCount(files.length);
  }

  useEffect(() => {
    updateData('artist', artist);
  }, [artist]);

  useEffect(() => {
    let files = [];
    if (orderData.option == 'later' && count > 0) {
      files = new Array(count).fill(0).map(() => ({
        path: '',
      }));
      updateData('fileList', files);
    }
  }, [count]);

  return (
    <PublicLayout>
      <div className="max-w-4xl mx-auto w-full p-4 text-center">
        <section className='my-8 sm:my-16'>
          <Row gutter={[24, 12]} align={"center"}>
            <Col span={24}>
              <p className='text-sm md:text-lg text-gray-400 italic'>All of our artists are experts in photo restoration & have years of experience</p>
            </Col>
            <Col span={24}>
              <div onClick={() => setArtist('mid')} className={classNames('h-full cursor-pointer relative rounded-xl')} styles={{ body: { height: '100%' } }}>
                {/* <div className='absolute top-5 right-5'><CheckCircleTwoTone style={{
                  fontSize: 20
                }} twoToneColor={artist == 'mid' ? '#0F0' : '#AAA'} /></div> */}
                <div className='flex items-center flex-wrap'>
                  <div className="w-1/2 sm:w-1/3 md:w-1/4 order-1 p-2">
                    <Carousel effect="fade" autoplay>
                      <img className='w-full rounded-xl' src="/imgs/ex1.webp" alt="" />
                      <img className='w-full rounded-xl' src="/imgs/ex2.webp" alt="" />
                      <img className='w-full rounded-xl' src="/imgs/ex3.webp" alt="" />
                    </Carousel>
                  </div>
                  <div className='w-0 sm:w-1/3 md:w-0 order-2'></div>
                  <div className='w-full md:w-2/4 order-4 md:order-3 flex flex-col px-4 md:px-8 justify-center text-left'>
                    <h1 className='my-2 md:my-2 text-[16px] sm:text-lg md:text-xl lg:text-2xl font-extrabold'>Expert Photo Restoration</h1>
                    <h1 className='my-1 md:my-1 text-sm md:text-[16px] font-bold flex items-center'><RiShieldCheckFill className='mr-2' /> Ready in 48-72 Hours</h1>
                    <h1 className='my-1 md:my-1 text-sm md:text-[16px] font-bold flex items-center'><RiShieldCheckFill className='mr-2' /> Unlimited Revisions</h1>
                    <h1 className='my-1 md:my-1 text-sm md:text-[16px] font-bold flex items-center'><RiShieldCheckFill className='mr-2' /> HD Digital Download</h1>
                    <h1 className='my-1 md:my-1 text-sm md:text-[16px] font-bold flex items-center'><RiShieldCheckFill className='mr-2' /> <span className='text-green-600'>100% Moneyback Guarantee</span></h1>
                  </div>
                  <div className="w-1/2 sm:w-1/3 md:w-1/4 order-3 md:order-4">
                    <div className='border border-solid border-gray-500 rounded-xl p-4'>
                      <span className='text-3xl font-extrabold'>
                        <span className='text-gray-500 line-through'>$65</span>&nbsp;
                        <span className='text-green-600'>$38</span>
                      </span>
                      <p className='mb-0 font-bold'>Per Restoration</p>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </section>
        <Divider className='my-12' />
        <section className="my-4">
          <Row gutter={[12, 12]}>
            <Col span={24}>
              <h1 className='text-xl md:text-2xl lg:text-3xl text-center font-extrabold'>Upload Your Photo(s)</h1>
              {/* <p>If you have reference photos, don't upload them here yet. If they are required, our artists will request them from you later.</p> */}
            </Col>
            <Col span={24}>
              <Dragger
                name="file"
                multiple={true}
                showUploadList={false}
                action={`${constants.HOST_URL}/order/upload`}
                accept="image/*"
                // data={{
                //   oldFile: imageUrl,
                // }}
                fileList={fileLists}
                onChange={handleChange}
              >
                <p className="ant-upload-drag-icon">
                  <img className='w-24' src="/imgs/upload.png" alt="" draggable={false} />
                </p>
                <Spin spinning={loading}>
                </Spin>
                <p className="ant-upload-text font-bold">Drag and Drop or Click to Upload</p>
                <h1 className='mt-4 text-lg md:text-xl text-center'>Uploaded: <span className='text-purple-700'>{orderData.fileList.length} Photos</span></h1>
                {/* <p className="ant-upload-hint">
                  Support for a single or bulk upload. Strictly prohibited from uploading company data or other
                  banned files.
                </p> */}
              </Dragger>
            </Col>
          </Row>
        </section>
        <Divider className='mt-12' />
        <section>
          <Row gutter={[24, 24]}>
            <Col span={24}>
              <h1 className='text-xl md:text-2xl lg:text-3xl text-center font-extrabold'>Bundle & Save</h1>
            </Col>
            <Col span={24}>
              <div className="flex flex-wrap">
                {orderData.fileList.map((file, index) => (
                  <div key={index} className='w-fit h-32 relative m-3'>
                    <Image height="100%" preview={!!file.path} className='object-cover' src={`${constants.SOCKET_URL}${file.path}`} alt="" fallback="data:image/png;base64,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" />
                    <div className="absolute -top-2 -right-2">
                      <Popconfirm
                        title="Delete!"
                        description="Are you sure to delete this photo?"
                        onConfirm={() => handleDelete(index)}
                      >
                        <div className='cursor-pointer p-1 bg-gray-200 rounded-full'>
                          <DeleteFilled style={{
                            color: 'red',
                          }} />
                        </div>
                      </Popconfirm>
                    </div>
                  </div>
                ))}
              </div>
            </Col>
            <Col xs={24} md={8}>
              <div className={
                classNames('py-2 sm:py-3 md:py-6 px-4 rounded-lg relative', 
                  (orderData.fileList.length >= 3 && orderData.fileList.length < 5) ? 'blurred-span' : isDarkMode ? 'border-2 border-solid border-gray-700' : 'border-2 border-solid border-gray-300',
                )}
              >
                <h1 className='text-2xl font-["Alexandria"] mb-1 font-semibold'>
                  3 Photos
                </h1>
                <span className='bg-green-600 text-white px-4 py-1 font-bold inline-flex items-center italic'>
                  <BiSolidPurchaseTag className='mr-1' />
                   Save $20
                </span>
              </div>
            </Col>
            <Col xs={24} md={8}>
              <div className={
                classNames('border-2 border-solid border-orange-500 py-2 sm:py-3 md:py-6 px-4 rounded-lg relative',
                  (orderData.fileList.length >= 5 && orderData.fileList.length < 10) ? 'blurred-span' : '',
                )}
              >
                <span className="absolute bg-orange-500 text-white font-bold px-2 py-1 italic top-0 left-1/2 -translate-y-full -translate-x-1/2 rounded-t">Most Popular</span>
                <h1 className='text-2xl font-["Alexandria"] mb-1 font-semibold'>5 Photos</h1>
                <span className='bg-green-600 text-white px-4 py-1 font-bold inline-flex items-center italic'><BiSolidPurchaseTag className='mr-1' /> Save $40</span>
              </div>
            </Col>
            <Col xs={24} md={8}>
              <div className={
                classNames('py-2 sm:py-3 md:py-6 px-4 rounded-lg relative', 
                  orderData.fileList.length >= 10 ? 'blurred-span' : isDarkMode ? 'border-2 border-solid border-gray-700' : 'border-2 border-solid border-gray-300',
                )}
              >
                <h1 className='text-2xl font-["Alexandria"] mb-1 font-semibold'>10 Photos</h1>
                <span className='bg-green-600 text-white px-4 py-1 font-bold inline-flex items-center italic'><BiSolidPurchaseTag className='mr-1' /> Save $100</span>
              </div>
            </Col>
            <Col span={24}>
              <h4 className='text-sm md:text-[16px] italic'><span className='text-green-500'>Discounts</span> are automatically applied to your order.</h4>
            </Col>
          </Row>
        </section>
        <Divider className='mt-12' />
        <section className="my-12">
          <Row gutter={[24, 24]}>
            <Col span={24}>
              <h1 className='max-w-2xl mx-auto text-xl md:text-3xl font-bold'>Any notes for the restoration artist <span className='text-gray-400 text-md md:text-xl'>(Optional)</span></h1>
            </Col>
            <Col span={24}>
              <Input.TextArea
                autoSize={{ minRows: 5, maxRows: 5 }}
                size="large"
                placeholder="Enter your notes here"
                value={orderData.note}
                onChange={(e) => updateData('note', e.target.value)}
              />
            </Col>
          </Row>
        </section>
        {orderData.fileList.length > 0 && <><Divider className='mt-2 mb-10' />
          <section className='my-8 sm:my-16'>
            <Row gutter={[24, 24]} align={"center"} className='bg-primary rounded-2xl shadow-lg'>
              <Col xs={24} md={12} className='!pl-0 !pr-0 md:!pr-2'>
                <div className='text-left rounded-2xl overflow-clip bg-cover p-8' style={{
                  backgroundImage: `url('${abg}')`,
                }}>
                  <ImgComparisonSlider hover className='slider-split-line rounded-2xl w-full'>
                    <figure slot="first" className="before">
                      <img className='w-full' src={`/imgs/before.webp`} alt="before" />
                      {/* <figcaption>Before</figcaption> */}
                    </figure>
                    <figure slot="second" className="after">
                      <img className='w-full' src={`/imgs/after.webp`} alt="after" />
                      {/* <figcaption>After</figcaption> */}
                    </figure>
                    <svg slot="handle" className="custom-animated-handle" xmlns="http://www.w3.org/2000/svg" width="100" viewBox="-8 -3 16 6">
                      <path stroke="#000" d="M -5 -2 L -7 0 L -5 2 M -5 -2 L -5 2 M 5 -2 L 7 0 L 5 2 M 5 -2 L 5 2" strokeWidth="1" fill="#fff" vectorEffect="non-scaling-stroke"></path>
                    </svg>
                  </ImgComparisonSlider>
                </div>
              </Col>
              <Col xs={24} md={12}>
                <div className="flex items-center h-full">
                  <div className="">
                    <div className='max-w-md mx-auto'>
                      <h1 className='text-xl md:text-2xl mt-4 mb-0 text-white'>Turn Black & White into Color!</h1>
                      <h1 className='text-xl text-black font-semibold'>+$9.99 per photo</h1>
                      <p className='text-white'>If your photo is faded, discolored or in black & white, and you would like this photo colorized, please select this option.</p>
                    </div>
                    <div className="overflow-auto max-h-48">
                      {orderData.fileList.map((file, index) => <div className='py-2 md:p-2 border-0 border-solid border-gray-200' key={index}>
                        {file.path ? <img src={`${constants.SOCKET_URL}${file.path}`} className='w-16 h-16 rounded shadow object-cover mr-4' alt="" /> : <div className='w-16 h-16 bg-gray-200 rounded shadow items-center justify-center mr-4 inline-flex'>
                          <h1 className="font-bold text-purple-600 m-0">{index + 1}</h1>
                        </div>}
                        <Button onClick={() => {
                          const files = orderData.fileList.map(file => ({ ...file }));
                          files[index].colorize = true;
                          updateData('fileList', files);
                        }} shape='round' type='primary' className='mr-2' icon={<CheckCircleFilled style={{ color: file.colorize ? 'orange' : '#888' }} />}>Yes Please</Button>
                        <Button onClick={() => {
                          const files = orderData.fileList.map(file => ({ ...file }));
                          files[index].colorize = false;
                          updateData('fileList', files);
                        }} shape='round' icon={<CloseCircleFilled style={{ color: file.colorize ? '#888' : 'red' }} />}>No Thanks</Button>
                      </div>)}
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </section></>}
        <Divider className='mt-2 mb-10' />
        <section className="my-8 sm:my-16">
          <Row gutter={[24, 24]} align={'center'}>
            <Col span={24}>
              <h1 className='text-xl md:text-2xl lg:text-3xl text-center mx-auto'>Need it Rushed?</h1>
            </Col>
            <Col xs={24} md={8}>
              <Card onClick={() => setProcessingDelay(1)} className={classNames('h-full cursor-pointer border-4 border-solid hover:shadow-lg relative', (processingDelay == 1 && isDarkMode) && 'border-orange-500 bg-gray-900', (processingDelay == 1 && !isDarkMode) && "border-orange-500 bg-orange-50", ((processingDelay != 1 && isDarkMode) && "border-gray-700"), ((processingDelay != 1 && !isDarkMode) && "border-gray-300"))} styles={{ body: { height: '100%' } }}>
                <div className='absolute top-5 left-5 md:left-auto md:right-5'><CheckCircleTwoTone className='text-lg' twoToneColor={processingDelay == 1 ? '#0F0' : '#AAA'} /></div>
                <div className='absolute w-44 top-0 -translate-x-1/2 -translate-y-1/2 left-[50%] text-sm font-bold text-white bg-orange-500 py-0.5 rounded italic'>Most Popular</div>
                <div className='flex flex-col justify-between items-center h-full pt-4'>
                  {/* <img src="/imgs/airplane-delivery-svgrepo-com.svg" className='w-16 sm:w-14 md:w-20' alt="" /> */}
                  <h1 className={classNames('text-xl sm:text-2xl md:text-4xl font-bold my-3', processingDelay == 1 ? (isDarkMode ? 'text-gray-200' : 'text-gray-600') : (isDarkMode ? 'text-gray-400' : 'text-gray-400'))}>24 Hours</h1>
                  <h2 className='text-sm sm:text-lg md:text-xl text-orange-500'>$9.99 PER PHOTO</h2>
                  <p className='font-bold'>{dayjs().add(1, 'day').format('dddd MMMM D')}</p>
                </div>
              </Card>
            </Col>
            <Col xs={24} md={8}>
              <Card onClick={() => setProcessingDelay(0)} className={classNames('h-full cursor-pointer border-4 border-solid hover:shadow-lg relative', (processingDelay == 0 && isDarkMode) && 'border-orange-500 bg-gray-900', (processingDelay == 0 && !isDarkMode) && "border-orange-500 bg-orange-50", ((processingDelay != 0 && isDarkMode) && "border-gray-700"), ((processingDelay != 0 && !isDarkMode) && "border-gray-300"))} styles={{ body: { height: '100%' } }}>
                <div className='absolute top-5 left-5 md:left-auto md:right-5'><CheckCircleTwoTone className='text-lg' twoToneColor={processingDelay == 0 ? '#0F0' : '#AAA'} /></div>
                <div className='flex flex-col justify-between items-center h-full pt-4'>
                  {/* <img src="/imgs/delivery-motorbike-svgrepo-com.svg" className='w-12 sm:w-14 md:w-16' alt="" /> */}
                  <h1 className={classNames('text-xl sm:text-2xl md:text-4xl font-bold my-3', processingDelay == 0 ? (isDarkMode ? 'text-gray-200' : 'text-gray-600') : (isDarkMode ? 'text-gray-400' : 'text-gray-400'))}>3 Days</h1>
                  <h2 className='text-sm sm:text-lg md:text-xl text-orange-500'>NO EXTRA CHARGE</h2>
                  <p className='font-bold'>{dayjs().add(3, 'day').format('dddd MMMM D')}</p>
                </div>
              </Card>
            </Col>
          </Row>
        </section>

        <Divider className='mt-2 mb-10' />
        <section className='mt-4 mb-8'>
          <Row gutter={[12, 12]}>
            <Col span={24}>
              <div className="flex items-center justify-center flex-wrap">
                <Button className='w-full sm:w-44 mx-0 sm:mx-2 m-2 inline-flex items-center justify-center' size='large' onClick={() => {
                  updateData('step', 0);
                  navigate('/order/step1');
                }}><PiArrowFatLeftFill /> &nbsp; Back</Button>
                <Button onClick={() => {
                  if (orderData.fileList.length == 0) {
                    return message.warning("Please upload your photos");
                  }
                  updateData('step', 2);
                  navigate('/order/step3');
                }} className='w-full sm:w-80 mx-0 sm:mx-2 m-2 inline-flex items-center justify-center' size='large' type='primary'>Click to go to Step 3 &nbsp; <PiArrowFatRightFill /> </Button>
              </div>
            </Col>
          </Row>
        </section>
      </div>
    </PublicLayout>
  )
}

export default Step2;